var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.element,{tag:"component",staticClass:"section-heading h2"},[_vm._t("default"),_c('IconTilde',{staticClass:"section-heading__icon"})],2)}
var staticRenderFns = []

export { render, staticRenderFns }